// Mock data for TheDeal Fitness website

export const siteData = {
  brand: {
    name: "THEDEAL",
    accentLetter: "E", // index 3 of THEDEAL will be highlighted yellow
    tagline: "FITNESS",
    location: "MANASSAS, VIRGINIA",
    certification: "CERTIFIED PERSONAL TRAINER",
    heroDescription: "Former athlete helping people of all ages and backgrounds get stronger, healthier, and more confident.",
    heroCallout: "LIVE THE DEAL!",
  },
  navigation: [
    { label: "HOMEPAGE", href: "#home" },
    { label: "SERVICES", href: "#services" },
    { label: "IN-PERSON TRAINING", href: "#in-person" },
    { label: "REMOTE", href: "#remote" },
    { label: "PROGRAMS", href: "https://dealfit.gumroad.com/l/jmuyf", external: true, newTab: true },
    { label: "GIRLS LAX", href: "/lacrosse/girls", external: true },
    { label: "BOYS LAX", href: "/lacrosse/boys", external: true },
    { label: "ABOUT", href: "#about" },
    { label: "SCHEDULE", href: "#contact" },
  ],
  services: [
    {
      id: "one-on-one",
      title: "ONE ON ONE\nTRAINING",
      description: "Achieve your fitness goals through personalized one-on-one workouts tailored to your abilities and needs.",
      icon: "UserRound",
      featured: true,
    },
    {
      id: "small-group",
      title: "SMALL GROUP\nTRAINING",
      description: "Push toward your goals with the benefits of one-on-one training in an energetic small group setting, at a discount.",
      icon: "Users",
    },
    {
      id: "remote",
      title: "REMOTE\nTRAINING",
      description: "Not local? Get trained by Chris anywhere in the world with fully guided remote sessions built around you.",
      icon: "Laptop2",
    },
    {
      id: "youth",
      title: "YOUTH\nTRAINING",
      description: "Speed, strength, agility and game-day skills for young athletes ready to level up their performance.",
      icon: "Trophy",
    },
    {
      id: "strength",
      title: "STRENGTH &\nCONDITIONING",
      description: "Get stronger and faster with programming built around your specific performance goals.",
      icon: "Dumbbell",
    },
    {
      id: "nutrition",
      title: "HEALTHY\nEATING",
      description: "Food powers your life. Customized nutrition plans that connect what you eat to how you perform.",
      icon: "Apple",
    },
  ],
  // In-person session packages — tiered hourly rate based on how many sessions you buy
  // Client picks the exact session count within each tier range inside the checkout modal
  inPersonPackages: [
    {
      id: "tier-1-5",
      minSessions: 1,
      maxSessions: 5,
      hourlyRate: 110,
      tag: null,
      label: "STARTER",
      note: "Try it out — no long-term commitment",
    },
    {
      id: "tier-6-10",
      minSessions: 6,
      maxSessions: 10,
      hourlyRate: 105,
      tag: null,
      label: "BUILD",
      note: "Build the habit, start seeing results",
    },
    {
      id: "tier-11-15",
      minSessions: 11,
      maxSessions: 15,
      hourlyRate: 100,
      tag: "POPULAR",
      label: "COMMIT",
      note: "Our most-booked tier — real transformation window",
    },
    {
      id: "tier-16-20",
      minSessions: 16,
      maxSessions: 20,
      hourlyRate: 95,
      tag: null,
      label: "LEVEL UP",
      note: "Push past plateaus and lock in new habits",
    },
    {
      id: "tier-21-25",
      minSessions: 21,
      maxSessions: 25,
      hourlyRate: 90,
      tag: "MAX VALUE",
      label: "ALL-IN",
      note: "Best per-session rate · season-long results",
    },
  ],
  // Evaluation card — standalone intro option, shown separately above the tiers
  evaluation: {
    id: "evaluation",
    label: "EVALUATION",
    duration: "30-min assessment",
    price: 50,
  },
  dropIn: {
    id: "drop-in",
    label: "DROP-IN",
    duration: "1-hour session",
    price: 120,
  },
  // Payment & cancellation policies displayed on the homepage
  policies: {
    payment: {
      heading: "PAYMENT POLICY",
      body:
        "Full payment is required for any scheduled session. Payment can be sent via Venmo, Cash App, or Zelle before your first session begins.",
      methods: ["Venmo: @Thedealfitness", "Cash App: $Thedealfitness", "Zelle: 315-272-0129"],
    },
    cancellation: {
      heading: "CANCELLATION POLICY",
      body:
        "I need a 24-hour notice if you cannot make it or need to cancel. Things happen — if there's a family emergency or you're sick, you do NOT forfeit a session. Just communicate with me and we'll work it out.",
      strict:
        "Cancellations within 3 hours of your scheduled session time forfeit the session.",
    },
  },
  customProgram: {
    title: "DEAL CUSTOM",
    subtitle: "Crank up your training with coaching made just for you!",
    startingPrice: 600,
    currency: "USD",
    note: "Final price depends on the selected program and included content",
    cta: "PURCHASE NOW",
  },
  virtualPrograms: [
    {
      id: "deal-jacked",
      name: "TDF JACKED",
      description: "Full-body strength made simple, structured, and powerful.",
      price: 119,
      features: [
        "Full-body training plan crafted for strength and peak performance",
        "Instructional videos and beginner-friendly warm-ups",
        "Self-guided progress tracking to see improvements at your own pace",
      ],
      tag: null,
      available: true,
    },
    {
      id: "deal-sprint",
      name: "TDF SPRINT",
      description: "Explosive legs, unstoppable speed. A defined program to unlock your fastest self.",
      price: 119,
      features: [
        "Progressive sprint mechanics and drills",
        "Plyometric strength progressions",
        "Weekly programming and mobility work",
      ],
      tag: null,
      available: true,
    },
    {
      id: "deal-bundle",
      name: "TDF BUNDLE",
      description: "Unlock your strength and speed potential with this complete bundle.",
      price: 230,
      basePrice: 238,
      savings: 8,
      features: [
        "Everything in TDF JACKED",
        "Everything in TDF SPRINT",
        "Bonus mobility & recovery guide",
      ],
      tag: "BEST VALUE",
      available: true,
    },
  ],
  about: {
    name: "CHRIS GARRETT",
    ownerLabel: "THE OWNER",
    badges: ["FORMER ATHLETE", "CPT", "FUNCTIONAL COACH"],
    paragraphs: [
      "After Chris's football and athletic careers came to an end in 2013, he was inspired to start training people to teach them how to live healthier and more functional lifestyles, regardless of age or ability.",
      "That vision soon became a reality. Chris built his client base in Winnipeg, Canada, then moved to Utica, New York, where his passion became a profession. In 2018 he relocated back to Manassas, Virginia, and continues to improve the lives of those who train with him.",
      "Chris trains people to live active lifestyles with functional training and to obtain a stronger mind and body. This isn't just his job \u2014 it's his life.",
    ],
    quote: "THEDEAL FITNESS IS A BRAND NAME. I OWN IT. I STAND BEHIND IT.",
  },
  testimonials: [
    {
      id: 1,
      name: "Marcus Reynolds",
      role: "Client, 2 years",
      initials: "MR",
      rating: 5,
      result: "Lost 42 lbs · Ran first 10K",
      quote:
        "Chris changed my life. I came in out of shape and doubting myself, and left every session stronger and clearer. He meets you where you are and pushes you where you need to be.",
    },
    {
      id: 2,
      name: "Ashley Nguyen",
      role: "Small group member",
      initials: "AN",
      rating: 5,
      result: "Down 3 dress sizes · PR deadlift 205 lbs",
      quote:
        "The small group sessions feel like family. Chris makes fitness fun and challenging without ever making you feel judged. I'm the strongest and most confident I've ever been.",
    },
    {
      id: 3,
      name: "Derrick Johnson",
      role: "Youth athlete parent",
      initials: "DJ",
      rating: 5,
      result: "Son gained a starting varsity spot",
      quote:
        "My son's speed, footwork and mindset transformed under Chris. Coaches at his school started noticing within a couple months. Worth every single session.",
    },
    {
      id: 4,
      name: "Priya Kapoor",
      role: "Remote client",
      initials: "PK",
      rating: 5,
      result: "Trained through pregnancy and post-partum",
      quote:
        "Even from another state, Chris made me feel like his top priority. Every program was tailored, every check-in was thoughtful. He's a coach and a friend.",
    },
    {
      id: 5,
      name: "Tom Bianchi",
      role: "One-on-one, age 58",
      initials: "TB",
      rating: 5,
      result: "Off two medications · Pain-free training",
      quote:
        "At 58 I thought my best days were behind me. Chris built a plan around my knees and my schedule. A year later I'm playing pickup basketball with my grandkids.",
    },
    {
      id: 6,
      name: "Jasmine Carter",
      role: "Nutrition + training",
      initials: "JC",
      rating: 5,
      result: "Body fat 28% → 19%",
      quote:
        "The eating plan finally clicked because Chris made it doable. No crash diets, just food I actually love. The training results speak for themselves.",
    },
  ],
  contact: {
    email: "thedealfitness@gmail.com",
    phone: "(315) 272-0129",
    address: "10521 Croatia Way, Manassas, VA 20109",
    addressShort: "Manassas, Virginia",
    socials: [
      { label: "Instagram", href: "https://www.instagram.com/thedealfitness/", icon: "Instagram" },
      { label: "Facebook", href: "https://www.facebook.com/thedealfitness", icon: "Facebook" },
      { label: "YouTube", href: "https://www.youtube.com/@thedealfitness", icon: "Youtube" },
      { label: "Twitter", href: "https://twitter.com/thedealfitness", icon: "Twitter" },
    ],
  },
  paymentMethods: [
    {
      id: "cashapp",
      name: "Cash App",
      handle: "$ThedealFitness",
      icon: "DollarSign",
      href: "https://cash.app/$ThedealFitness",
      accent: "#00d54b",
    },
    {
      id: "venmo",
      name: "Venmo",
      handle: "@thedealfitness",
      icon: "Send",
      href: "https://venmo.com/thedealfitness",
      accent: "#008cff",
    },
    {
      id: "zelle",
      name: "Zelle",
      handle: "315-272-0129",
      icon: "Smartphone",
      href: "tel:3152720129",
      accent: "#6d1ed4",
    },
  ],
  // Team/group pricing tiers (lacrosse & other squads)
  teamPackages: [
    {
      id: "team-squad",
      name: "SQUAD",
      subtitle: "Position groups & small squads",
      maxAthletes: 6,
      sessions: 8,
      price: 3120,
      perPlayerPerSession: 65,
      tag: null,
      features: [
        "Up to 6 athletes per session",
        "8 training sessions (~4 weeks)",
        "Sport-specific conditioning & drills",
        "Group accountability & team energy",
      ],
    },
    {
      id: "team-full",
      name: "FULL TEAM",
      subtitle: "Best fit for high-school & club rosters",
      maxAthletes: 12,
      sessions: 8,
      price: 5760,
      perPlayerPerSession: 60,
      tag: "POPULAR",
      features: [
        "Up to 12 athletes per session",
        "8 training sessions (~4 weeks)",
        "Position breakdowns + full-team scrims",
        "Free coach/trainer consultation",
      ],
    },
    {
      id: "team-season",
      name: "SEASON PROGRAM",
      subtitle: "Full pre-season into in-season block",
      maxAthletes: 15,
      sessions: 16,
      price: 12000,
      perPlayerPerSession: 50,
      tag: "MAX VALUE",
      installmentPlan: {
        count: 4,
        amountEach: 3000,
        cadence: "monthly",
      },
      features: [
        "Up to 15 athletes per session",
        "16 training sessions (~8-12 weeks)",
        "Pre-season buildout + in-season maintenance",
        "Weekly progress reports for coaches",
      ],
    },
  ],
  // Calendly event type URLs — replace each with your own Calendly event slug
  // Current setup uses your existing "30min" event for everything so bookings work today
  calendly: {
    assessment: "https://calendly.com/thedealfitness/30min",
    session: "https://calendly.com/thedealfitness/30min",
    kickoff: "https://calendly.com/thedealfitness/30min",
    hero: "https://calendly.com/thedealfitness/30min",
  },
  // Booking notification — Formsubmit.co (free, no signup required)
  // On first booking, Chris receives a one-time confirmation email at this address —
  // click the link in it to activate. After that, every completed booking auto-emails him.
  notify: {
    email: "thedealfitness@gmail.com",
    endpoint: "https://formsubmit.co/ajax/thedealfitness@gmail.com",
  },
  // Square payment links — paste the full URL from Square for each package.
  // Use `default` as a fallback "any amount" link so bookings can always take a card payment.
  // Update these as you generate per-package payment links in Square.
  cardPayments: {
    provider: "Square",
    default: "https://square.link/u/9Aaj0v1h",
    byId: {
      // Evaluation
      "evaluation": "",
      "drop-in": "",
      // In-person packages (session-based)
      "sess-10": "",
      "sess-20": "",
      "sess-30": "",
      "sess-40": "",
      "sess-50": "",
      // Virtual programs
      "deal-jacked": "",
      "deal-sprint": "",
      "deal-bundle": "",
      // Team packages
      "team-squad": "",
      "team-full": "",
      "team-season": "",
    },
    // Optional: separate URLs for the installment/subscription mode.
    // Create a Square Subscription for $3,000/month × 4 months and paste the URL here.
    // When a coach picks the "4-Payment Plan" toggle, they'll be sent to the subscription link
    // that auto-charges the remaining 3 payments each month.
    subscriptionsById: {
      "team-season": "",
    },
    // Accepted methods shown as badges on the checkout button
    acceptedMethods: ["Credit Card", "Apple Pay", "Google Pay"],
  },
};
